import { Component, Input, OnInit } from '@angular/core';
import { ChartOptions, ChartType } from 'chart.js';
import { FormControl } from '@angular/forms';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';

@Component({
	selector: 'school-analytics',
	templateUrl: 'school-analytics.component.html',
	styleUrls: ['school-analytics.component.scss']
})

export class SchoolAnalyticsComponent implements OnInit {
	@Input() deviceId:number | undefined =  -1;
	@Input() schoolId:number | undefined =  -1;
	@Input() projectId:number | undefined =  -1;
	reports: ReportItem[] = [];
	generalReports: ReportItem[] = [];
	mcfReports: ReportItem[] = [];
	youtubeReports: ReportItem[] = [];
	report : number = 0;
	useTabs: boolean = false;
	selectedTabIndex: number = 0;
	mcfTileView: [number, number] = [350, 200];
	startDate: Date | null = null;
	endDate: Date | null = null;
	startDateMax?: Date;

	onStartDateChange(event: MatDatepickerInputEvent<Date>) {
		this.startDate = event.value;
	  }



	  public pieChartData: number[] = [];
	  public pieChartType: ChartType = 'bar';
	  public pieChartLegend = false;
	  public pieChartColors = [
		{
		  backgroundColor: ['#016CA7', '#018DBB', '#01A9CD', '#07B4BF', '#10B8A3', '#3EBD7E','#7FC34F'],
		},
	  ];

	public barChartOptions = {
		scaleShowVerticalLines: false,
		responsive: true
	  };

	ngOnInit() {
		const today = new Date();
		this.endDate = today;
		const threeMonthsAgo = new Date(today);
		threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 3);
		this.startDate = threeMonthsAgo;
		this.loadReports();
	}

	back(){
		this.report = 0;
	}

	private loadReports(){
		const deivcesync = new ReportItem("Devices Synched",1,"assets/images/devicereport.svg");
		const apputilization = new ReportItem("eKitabu App Utilization",3,"assets/images/heatmap.svg");
		const titlereport = new ReportItem("Books Read by Title",2,"assets/images/titlereport.svg");
		const subjectreport = new ReportItem("Books Read by Subject",4,"assets/images/subjectreport.svg");
		const timereport = new ReportItem("Total time used by day",5,"assets/images/timereport.svg");
		const utilreport = new ReportItem("Utilization Across Sites",6,"assets/images/gridutilreport.svg");
		const learnersPerformance = new ReportItem("Learners' Performance",8,"assets/images/gridutilreport.svg");
		const mostwatched = new ReportItem("Most Watched Videos",9,"assets/images/gridutilreport.svg");
		const mostwatchedbytheme = new ReportItem("Most Watched Videos by Theme",10,"assets/images/gridutilreport.svg");
		const pp2vocabquiz = new ReportItem("PP2 Vocabulary Quiz Responses",11,"assets/images/gridutilreport.svg");
		const youtubeViewsPerVideo = new ReportItem("YouTube Views per Video",12,"assets/images/gridutilreport.svg");
		const youtubeViewsPerCategory = new ReportItem("YouTube Views per Category",13,"assets/images/gridutilreport.svg");

		// Determine tab usage
		this.useTabs = (this.projectId == 25);

		// Populate General (Learning Analytics) reports
		this.generalReports = [];
		if(this.deviceId == -1)
			this.generalReports.push(deivcesync);
		this.generalReports.push(apputilization, titlereport, subjectreport, timereport);
		if(this.schoolId == -1 && this.deviceId == -1)
			this.generalReports.push(utilreport);
		// util devices report currently excluded by original logic

		// Populate MCF Learning Analytics (only when projectId == 25)
		this.mcfReports = [];
		this.youtubeReports = [];
		if(this.useTabs){
			// MCF specific reports
			this.mcfReports.push(learnersPerformance, mostwatched, mostwatchedbytheme, pp2vocabquiz);
			// YouTube specific reports
			this.youtubeReports.push(youtubeViewsPerVideo, youtubeViewsPerCategory);
		}

		// For non-25 projects, keep original behavior (single list = general only)
		this.reports = this.generalReports;

		this.pieChartData = [1,2,1,3,1,2,1];

	}

 	selectReport(id: number){
			this.report = id;
	}

	getReportTitle(): string {
		const all: ReportItem[] = [...this.generalReports, ...this.mcfReports, ...this.youtubeReports];
		const found = all.find(r => r.id === this.report);
		return found ? String(found.name) : '';
	}

	onTabIndexChange(index: number) {
		// Preserve the selected tab index for navigation back
		this.selectedTabIndex = index;
		// When switching to the MCF or YouTube tab, force a view rebinding so ngx-charts lays out correctly
		if (this.useTabs && (index === 1 || index === 2)) {
			setTimeout(() => {
				this.mcfTileView = [this.mcfTileView[0], this.mcfTileView[1]];
			});
		}
	}

}

class ReportItem{
	name: string;
	id: number;
	url: string;

	constructor(name: string, id: number, url: string){
		this.name = name;
		this.id = id;
		this.url = url;
	}
}
